var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"h-tabs","mode":"out-in"}},[(_vm.show)?_c('div',{staticClass:"photon-wrap"},[_c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":require("@/assets/component/photon.png"),"alt":""}}),_vm._v(" "),_c('div',{style:({ color: _vm.color })},[_vm._v("光子+"+_vm._s(_vm.photonNum))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc1a087a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/gtn/components/pnoton.vue
// module id = null
// module chunks = 